<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
      <el-form-item label="预付款订单：" prop="orderId">
        <order-drop v-model="dataForm.orderId" size="normal" val-name="id"></order-drop>
      </el-form-item>
      <el-form-item label="收款公司：" prop="receiverId">
        <company v-model="dataForm.receiverId"  size="normal"></company>
      </el-form-item>
      <el-form-item label="预付款金额：" prop="payAmount">
        <el-input v-model="dataForm.payAmount" placeholder="预付款金额"></el-input>
      </el-form-item>
      <el-form-item label="付款时间：" prop="payDate">
        <el-date-picker value-format="yyyy-MM-dd"  v-model="dataForm.payDate" style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="付款银行：" prop="payBank">
        <el-input v-model="dataForm.payBank" placeholder="付款银行"></el-input>
      </el-form-item>
      <el-form-item label="付款账户：" prop="payAccount">
        <el-input v-model="dataForm.payAccount" placeholder="付款账户"></el-input>
      </el-form-item>
      <el-form-item label="收款行：" prop="receiverBank">
        <el-input v-model="dataForm.receiverBank" placeholder="收款行"></el-input>
      </el-form-item>
      <el-form-item label="收款账户：" prop="receiverAccount">
        <el-input v-model="dataForm.receiverAccount" placeholder="收款账户"></el-input>
      </el-form-item>
      <el-form-item label="收款人：" prop="receiverName">
        <el-input v-model="dataForm.receiverName" placeholder="收款人"></el-input>
      </el-form-item>
      <el-form-item label="备注：" prop="remark">
        <el-input v-model="dataForm.remark" type="textarea" :rows="6" placeholder="备注"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { moneyValidator } from '@/utils/validate'
import moment from 'moment'
export default {
  data () {
    return {
      id: '',
      visible: false,
      dataForm: {}
    }
  },
  computed: {
    dataRule () {
      return {
        orderId: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ], receiverId: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ], payAmount: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' },
          { validator: moneyValidator, trigger: "change" },
        ], payDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    reset () {
      this.dataForm = {
        orderId: '',
        receiverId: '',
        payAmount: '',
        payNo: '',
        payDate: moment().format('yyyy-MM-DD'),
        payBank: '',
        payAccount: '',
        receiverBank: '',
        receiverAccount: '',
        receiverName: '',
        imgs: '',
        remark: '',
      }
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].resetFields()
      }
    },
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.reset()
        if (this.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/erp/per/${this.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {
      })
    },

    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let postForm = {
          ...this.dataForm
        }
        this.$http[!postForm.id ? 'post' : 'put']('/erp/per/pay/', postForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.cancel()
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    cancel () {
      this.visible = false
    }
  }
}
</script>
